export enum PracticeResultsTabs {
  DESCRIPTION = 'Description',
}
